import { route } from '@/ziggy-shim';
import { api, apiConfig, CastValue } from './LaravelClient';

export default {
  async create(claimId: Id, data: ApiRequests['api.v1.subcontractor.claims.lite.dayworks.store']) {
    return await api(route('api.v1.subcontractor.claims.lite.dayworks.store', claimId), 'post', {
      data,
      casts: {
        current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        labour_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        plant_id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async update(id: Id, data: ApiRequests['api.v1.dayworks-costs.update']) {
    return await api(route('api.v1.dayworks-costs.update', id), 'patch', {
      data,
      casts: {
        current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        current_claim: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async delete(id: Id) {
    return await api(route('api.v1.dayworks-costs.destroy', id), 'delete');
  },

  async subcontractorClaim(
    claimId: Id,
    signedParams: unknown,
    data: ApiRequests['api.v1.subcontractor.claims.dayworks.claim.store'],
  ) {
    return await apiConfig(route('api.v1.subcontractor.claims.dayworks.claim.store', claimId), 'post', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
      casts: {
        id: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
      },
    });
  },

  async subcontractorDelete(
    claimId: Id,
    signedParams: unknown,
    data: ApiRequests['api.v1.subcontractor.claims.dayworks.claim.destroy'],
  ) {
    return await apiConfig(route('api.v1.subcontractor.claims.dayworks.claim.destroy', claimId), 'delete', {
      params: signedParams,
      paramsSerializer: {
        serialize: (params) => {
          return new URLSearchParams(params).toString();
        },
      },
    }, {
      data,
    });
  },

  async subcontractorCertified(
    projectId: Id,
    claimId: Id,
    dayworksCostId: Id,
    data: ApiRequests['api.v1.subcontractor.claims.dayworks.certified.store'],
  ) {
    return await api(
      route('api.v1.subcontractor.claims.dayworks.certified.store', [projectId, claimId, dayworksCostId]),
      'post',
      {
        data,
        casts: {
          comment: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
          current_certified: (value, clone, key) => new CastValue(value).cast('nullable', clone, key).get(),
        },
      },
    );
  },

  async fetchLabourRecords(
    projectId: Id,
    claimId: Id,
    labourId: Id,
    page = 1,
  ) {
    return await apiConfig(
      route('api.v1.subcontractor.claims.dayworks.labour.records', [projectId, claimId, labourId]),
      'get',
      {
        params: {
          page,
        },
      },
    );
  },

  async fetchPlantRecords(
    projectId: Id,
    claimId: Id,
    plantId: Id,
    page = 1,
  ) {
    return await apiConfig(
      route('api.v1.subcontractor.claims.dayworks.plant.records', [projectId, claimId, plantId]),
      'get',
      {
        params: {
          page,
        },
      },
    );
  },

  async export(projectId: Id, claimId: Id) {
    return await api(route('api.v1.subcontractor.claims.dayworks.export', [projectId, claimId]), 'post');
  },
};
